import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GerenciarPerfisUsuariosApiService } from '../../services/gerenciar-perfis-usuarios-api.service';
import { Usuario } from '../../models/usuario';
import { Papel } from '../../models/papel';
import { MessageService } from '@services/message.service';
import { CriarPapelDialogComponent } from './criar-papel-dialog/criar-papel-dialog.component';
import { ItemSelecao } from '../shared/paineis-selecao-checkboxes/item-selecao';
import { PaineisSelecaoCheckboxesComponent } from '../shared/paineis-selecao-checkboxes/paineis-selecao-checkboxes.component';

const NOME_PAPEL_ADMIN = 'ADMIN';

@Component({
  selector: 'app-editar-papeis-usuario',
  templateUrl: './editar-papeis-usuario.component.html',
  styleUrl: './editar-papeis-usuario.component.scss',
  standalone: false,
})
export class EditarPapeisUsuarioComponent {

  @Input() usuarios: Usuario[] = [];

  @Input() set papeis(value: Papel[]) {
    this._papeis = value;
    if (this.usuarioSelecionadoId !== null) this.computarItensDireita();
  }
  get papeis(): Papel[] { return this._papeis; }
  private _papeis: Papel[] = [];

  @Output() usuariosChange = new EventEmitter<Usuario[]>();
  @Output() papeisChange = new EventEmitter<Papel[]>();
  @ViewChild(PaineisSelecaoCheckboxesComponent) paineis!: PaineisSelecaoCheckboxesComponent;

  get itensEsquerda(): ItemSelecao[] {
    return this.usuarios.map(u => ({ id: u.id, label: u.login }));
  }

  itensDireita: ItemSelecao[] = [];
  tituloDireita: string = '';
  salvando = false;

  private usuarioSelecionadoId: number | null = null;
  private selecionadosIds: Set<number> = new Set();

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) { }

  public onItemSelecionado(item: ItemSelecao): void {
    this.usuarioSelecionadoId = item.id;
    const usuario = this.usuarios.find(u => u.id === item.id)!;
    this.tituloDireita = `Papéis de ${usuario.login}`;
    this.selecionadosIds = new Set(usuario.papeis.map(p => p.id));
    this.computarItensDireita();
  }

  public onToggleItem(evento: { item: ItemSelecao; checked: boolean }): void {
    if (evento.checked) {
      this.selecionadosIds.add(evento.item.id);
    } else {
      this.selecionadosIds.delete(evento.item.id);
    }
    const item = this.itensDireita.find(i => i.id === evento.item.id);
    if (item) item.checado = evento.checked;
  }

  public onSalvar(evento: { esquerdaId: number }): void {
    this.salvando = true;
    const direitaIds = [...this.selecionadosIds];
    this.gerenciarPerfisUsuariosApiService.editarPapeisUsuario(evento.esquerdaId, direitaIds).subscribe({
      next: () => {
        const usuario = this.usuarios.find(u => u.id === evento.esquerdaId)!;
        const novosPapeis = this._papeis.filter(p => direitaIds.includes(p.id));
        const usuarioAtualizado: Usuario = { ...usuario, papeis: novosPapeis };

        this.usuariosChange.emit(
          this.usuarios.map(u => u.id === usuarioAtualizado.id ? usuarioAtualizado : u)
        );

        this.messageService.showToastSuccess(`Papéis de "${usuarioAtualizado.login}" atualizados com sucesso.`);
        this.salvando = false;
      },
      error: () => {
        this.salvando = false;
      }
    });
  }

  public abrirCriarPapelDialog(): void {
    const dialogRef = this.dialog.open(CriarPapelDialogComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((novoPapel: Papel | null) => {
      if (novoPapel) {
        this.papeisChange.emit([...this._papeis, novoPapel]);
      }
    });
  }

  public filtrar(valor: string): void {
    this.paineis.filtrar(valor);
  }

  private computarItensDireita(): void {
    const usuario = this.usuarios.find(u => u.id === this.usuarioSelecionadoId);
    if (!usuario) return;
    const temAdmin = usuario.papeis.some(p => p.nome === NOME_PAPEL_ADMIN);
    this.itensDireita = this._papeis.map(p => ({
      id: p.id,
      label: p.nome,
      sublabel: p.descricao,
      checado: this.selecionadosIds.has(p.id),
      bloqueado: temAdmin && p.nome === NOME_PAPEL_ADMIN,
      tooltipBloqueado: 'O papel ADMIN não pode ser removido após ser atribuído',
    }));
  }
}
